import { render, staticRenderFns } from "./BoxReuse.vue?vue&type=template&id=49fffd6d&scoped=true&"
import script from "./BoxReuse.vue?vue&type=script&lang=js&"
export * from "./BoxReuse.vue?vue&type=script&lang=js&"
import style0 from "./BoxReuse.vue?vue&type=style&index=0&id=49fffd6d&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49fffd6d",
  null
  
)

export default component.exports